import React, { useEffect, useState } from 'react';
import PinInput from 'react-pin-input';
import { Link, useNavigate } from 'react-router-dom';
import ModalBox from '../../../components/ModalBox';
import gameAPI from '../../../api/gameAPI';
import AuthenticationManager from '../../../services/StorageJWT';
import PopupBox from '../../../components/PopupBox';
import { useAuth } from '../../../provider/AuthProvider';
import Ratio from 'react-bootstrap/Ratio';
import { Button, Spinner } from 'react-bootstrap';
import { onKeyDown } from '../../../services/Tools';

const Answer = () => {
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [show, setShow] = useState(true);
  const [loading, setLoadig] = useState(false);
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  var _auth= new AuthenticationManager();
  // useEffect(()=>{
  //   if(token.user.status==1) navigate("/one/contacts")
  // })
  const onSubmit = () => {
    try {
      setLoadig(true);
      gameAPI
        .verify(code, _auth._token)
        .then((res) => {
          _auth.updateProfile(res)

          navigate('/one/call');
        })
        .catch((e) => {
          if (e.response.data) {
            setError(e.response.data.error);
            setShowError(true);
          }
        })
        .finally(() => setLoadig(false));
    } catch {}
  };

  return (
    <>
      <div className=" p-3 open-lock pt-5">
        <img src="/images/frame.png" alt="" id='frame' />
        <img src="/icons/lock3.svg" alt="" />
        {/* <input
          type="text"
          onKeyDown={(e) => onKeyDown(e, onSubmit)}
          onChange={(e) => setCode(e.target.value)}
          className="form-control w-100"
          placeholder="رمز پایانی را وارد نمایید..."
        /> */}
        <h6 className='text-white '>Enter Your Password</h6>
        <div className='pin-pos' dir='ltr'>
          <span className={code.length>=1?"active":"inactive"}></span>
          <span  className={code.length>=2?"active":"inactive"}></span>
          <span  className={code.length>=3?"active":"inactive"}></span>
          <span  className={code.length>=4?"active":"inactive"}></span>
          <span  className={code.length>=5?"active":"inactive"}> </span>
        </div>
        <div dir='ltr'>
        <PinInput
            length={5}
            initialValue=""
            focus
            
            onChange={(value, index) => {  setCode(value);}}
            type="alphanumeric"
            inputMode="alphanumeric"
            style={{ padding: 1, }}
            inputStyle={{
              borderRadius: 0,
              backgroundColor:"transparent",
              width:40,
              color:"white",
              borderColor: "white",
              borderTop: 0,
              borderLeft: 0,
              borderRight: 0,
              fontSize:17
            }}
            inputFocusStyle={{  width:40, }}
            onComplete={(value, index) => {
              setCode(value);
            
            }}
            autoSelect={true}
            // regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          />
          </div>
        <Button
          variant="dark"
          className="btn btn-tik  d-flex justify-content-center mb-5 "
          onClick={onSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="p-2"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <img src="/icons/tik.svg" />
          )}
        </Button>
      </div>
      <PopupBox text={error} setShow={setShowError} show={showError} />
    </>
  );
};
export default Answer;
